var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-body overflow-visible" },
    [
      _vm.isBusy || (_vm.items && _vm.items.length > 0)
        ? [
            _c(
              "div",
              { staticClass: "page-table-container overflow-visible" },
              [
                _c("b-table", {
                  ref: "location_work_services",
                  staticClass: "custom-table mb-0",
                  attrs: {
                    id: "location-work-services",
                    busy: _vm.isBusy,
                    items: _vm.items,
                    fields: _vm.fields,
                    "current-page": _vm.currentPage,
                    "per-page": _vm.perPage,
                    "sort-by": _vm.sortBy,
                    "sort-desc": _vm.sortDesc,
                    "sort-compare": _vm.sortCompare,
                    "no-provider-filtering": "",
                    "no-provider-paging": "",
                    "no-provider-sorting": ""
                  },
                  on: {
                    "update:busy": function($event) {
                      _vm.isBusy = $event
                    },
                    "update:sortBy": function($event) {
                      _vm.sortBy = $event
                    },
                    "update:sort-by": function($event) {
                      _vm.sortBy = $event
                    },
                    "update:sortDesc": function($event) {
                      _vm.sortDesc = $event
                    },
                    "update:sort-desc": function($event) {
                      _vm.sortDesc = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "table-busy",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              { staticClass: "text-center text-success my-2" },
                              [
                                _c("b-spinner", {
                                  staticClass: "align-middle"
                                }),
                                _vm._v(" "),
                                _c("strong", [_vm._v("Загрузка")])
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "cell(work_service)",
                        fn: function(row) {
                          return [
                            _c("work-service-select", {
                              ref: "work_service_select",
                              attrs: {
                                id: "work-service-select",
                                "is-disabled": _vm.isDisabled,
                                value: row.item.work_service_id
                              },
                              on: {
                                onSelect: function($event) {
                                  return _vm.onSelectWorkService($event, row)
                                }
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "cell(price)",
                        fn: function(row) {
                          return [
                            _c("b-form-input", {
                              attrs: {
                                id: "input-price",
                                size: "sm",
                                disabled: _vm.isDisabled,
                                autocomplete: "off",
                                type: "number"
                              },
                              model: {
                                value: row.item.price,
                                callback: function($$v) {
                                  _vm.$set(row.item, "price", _vm._n($$v))
                                },
                                expression: "row.item.price"
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "cell(unit)",
                        fn: function(row) {
                          return [
                            _c("unit-select", {
                              ref: "unit_select",
                              attrs: {
                                id: "input-unit",
                                "is-disabled": _vm.isDisabled,
                                "initial-unit": row.item.unit_code,
                                "is-short": ""
                              },
                              on: {
                                selectUnit: function($event) {
                                  return _vm.onSelectUnit($event, row)
                                }
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "head(action)",
                        fn: function(row) {
                          return [
                            _c(
                              "b-btn",
                              {
                                staticStyle: {
                                  color: "#1A9167 !important",
                                  "text-decoration": "none !important"
                                },
                                attrs: {
                                  variant: "link",
                                  disabled: _vm.isDisabled
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.onAdd()
                                  }
                                }
                              },
                              [
                                _c("v-icon", {
                                  staticClass: "mr-1",
                                  attrs: { name: "buttons/plus", size: 12 }
                                }),
                                _vm._v("\n            Добавить\n          ")
                              ],
                              1
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(action)",
                        fn: function(row) {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: "link",
                                  disabled: _vm.isDisabled
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onRemove(row)
                                  }
                                }
                              },
                              [
                                _c("v-icon", {
                                  attrs: { name: "buttons/trash", size: 16 }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2731015094
                  )
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "page-pagination" },
              [
                _c("pagination-footer", {
                  attrs: {
                    "total-rows": _vm.items.length,
                    "per-page": _vm.perPage,
                    "current-page": _vm.currentPage
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    },
                    "per-page-change": _vm.onPerPageChange
                  }
                })
              ],
              1
            )
          ]
        : _c(
            "div",
            { staticClass: "empty-state-container" },
            [
              _c("v-icon", { attrs: { name: "navbar/empty_table", size: 90 } }),
              _vm._v(" "),
              _c("h5", [_vm._v("Нет добавленных услуг.")]),
              _vm._v(" "),
              _c("p", [_vm._v("Добавьте услуги исполнителей прямо сейчас")]),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  staticClass: "custom-btn-primary mt-1",
                  attrs: { disabled: _vm.isDisabled },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.onAdd()
                    }
                  }
                },
                [
                  _c("v-icon", {
                    staticClass: "mr-1",
                    attrs: { name: "buttons/plus", size: 12 }
                  }),
                  _vm._v("\n      Новая услуга\n    ")
                ],
                1
              )
            ],
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b2d48c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b2d48c5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/LocationWorkServices.vue
// module id = null
// module chunks = 